// The languages the platform is translated into.
//
// One list, because there are three switchers — the top menu, the landing page
// and the sign-in panel — and keeping them in step by hand did not work:
// Chinese shipped in the top menu and was missing from the other two.
// Adding a language here adds it everywhere; it still needs its own block in
// i18n.js to be worth offering.

export const LANGUAGE_OPTIONS = [
  { code: "en", label: "English" },
  { code: "fr", label: "Français" },
  { code: "es", label: "Español" },
  { code: "it", label: "Italiano" },
  { code: "de", label: "Deutsch" },
  { code: "pt", label: "Português" },
  { code: "zh", label: "中文" },
];

export const LANGUAGE_CODES = LANGUAGE_OPTIONS.map((l) => l.code);
